import {isNullOrEmpty} from './HelperUtils';


export const getTab = (tab: string, tabs: string[]): string => {
    if ((tabs === undefined) || (!tabs) || (tabs.length === 0)) {
        return tab ?? '';
    }

    if ((tab === undefined) || (isNullOrEmpty(tab))) {
        return tabs[0];
    }

    return (tabs.find((tabKey) => tabKey === tab)) ?? tabs[0];
};
